import {BaseOptions} from "../../../../dialog/options/base.options";

export class AddOrUpdateBusinessOptions extends BaseOptions {
  business?: any;
  parentId?: any;

  onInsertOrUpdateFinished() {
  }
}
